window.__defaultQuestionHandler = {


    toggleVisibility: function(elm) {

        let parent = elm.closest('.default-question-row');

        let checkbox = parent.querySelector('.default-question-hide-checkbox');

        checkbox.checked = !checkbox.checked;

        if (checkbox.checked) {
            parent.classList.remove('default_question_shown');
            parent.classList.add('default_question_hidden');
        } else {
            parent.classList.add('default_question_shown');
            parent.classList.remove('default_question_hidden');
        }

        return false;

    },

    toggleEditing: function(elm) {
        let parent = elm.closest('.default-question-row');

        parent.classList.toggle('default_question_editing');

        return false;
    }

}

let isHighschoolOnlyInput = document.querySelector('[name="is_highschool_only"]');
if (isHighschoolOnlyInput) {

    isHighschoolOnlyInput.addEventListener('change', function(event) {

        let isHighschoolOnly = event.target.checked;

        let schoolQuestionText = document.querySelector('.default-question-row--school .default-question-title');
        if (schoolQuestionText) {
            
            if (isHighschoolOnly) {
                schoolQuestionText.innerText = 'Lise';
            } else {
                schoolQuestionText.innerHTML = 'Okul';
            }

        }

    });


}